import React, { createContext, useContext, ReactElement } from 'react'
import { initialState } from './_state'
import { useHandlers } from '@src/containers/UtmGenerator/hooks'

type Props = {
  children: ReactElement
}

const HTTPContext = createContext(initialState)

export function HTTPProvider({ children }: Props): ReactElement {
  const [state, func] = useHandlers(initialState)

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return <HTTPContext.Provider value={{ ...state, ...func }}>{children}</HTTPContext.Provider>
}

export function useHTTPContext() {
  return useContext(HTTPContext)
}
